<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">我的客户</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('46')"
        >添加
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 300px"
          placeholder="名称、信用代码"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        />
        <el-input
          v-model="state.params.keywords_subaccount"
          style="width: 300px"
          placeholder="子账户关键词"
          clearable
          @clear="
            delete state.params.keywords_subaccount;
            onLoad();
          "
          @paste.enter="
            $onKeywordsPaste($event, state.params, 'keywords_subaccount')
          "
        >
          <template #suffix>
            <el-tooltip
              effect="dark"
              content="支持子账户名称、银行、开户行、账号、统一社会信用代码"
              placement="top-start"
            >
              <el-icon style="cursor: pointer"><QuestionFilled /></el-icon>
            </el-tooltip>
          </template>
        </el-input>
        <el-radio-group v-model="state.params.status">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="1">正常</el-radio-button>
          <el-radio-button :value="0">停用</el-radio-button>
        </el-radio-group>
        <el-select
          style="width: 200px"
          v-model="state.params.d_customer_type_id"
          placeholder="客户类型"
        >
          <el-option
            v-for="item in state.customertypeData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-tree-select
          v-model="state.params.belonger_id"
          :props="{
            value: 'id',
            label: 'name',
            class: 'belonger-tree-class',
          }"
          placeholder="业务员"
          :data="state.admin_data"
          style="width: 200px"
          default-expand-all
          filterable
          clearable
        >
          <template #default="{ data }">
            <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
            <el-icon :size="16" v-else><User /></el-icon>
            <span style="margin-left: 3px">{{ data.name }}</span>
          </template>
        </el-tree-select>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="签约日期"
          end-placeholder="签约日期"
          value-format="YYYY-MM-DD"
          style="width: 300px"
          @change="
            (value) => {
              if (value)
                state.params.contract_time = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.contract_time;
          "
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          sortable="status"
          width="100"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.status == 1 ? '正常' : '停用',
                Color: row.status == 1 ? '#1e90ff' : '#f00',
              })
          "
        />
        <el-table-column prop="d_customer_type_name" label="类型" width="120" />
        <el-table-column prop="name" label="名称" :min-width="220">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="名称"
              @click="$onCopy(row.name)"
            >
              {{ row.name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="所属地区"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.province + (row.city || '') + (row.district || ''),
                row.address || ''
              )
          "
          :min-width="220"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          :formatter="$tab_TextFormat"
          width="200"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="contact_name"
          label="联系人"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="contact_phone"
          label="联系方式"
          :formatter="$tab_TextFormat"
          width="160"
        />
        <el-table-column
          prop="contract_time"
          label="签约时间"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="payroll_person_num"
          label="在册人员"
          align="center"
          width="120"
        />
        <el-table-column label="负责人" :min-width="220">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text v-if="row.belonger_department_name">{{
              "/" + row.belonger_department_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'CustomerDetail',
                  title: row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="$judge_auth('47')"
            >
              管理
            </el-button>
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                $store.commit('openMenu', {
                  path: 'CustomerDetail',
                  title: row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-else
            >
              查看
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('48')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '客户'"
        @close="state.showInfo = false"
      >
        <c_CustomerInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_CustomerInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showBelonger"
        title="选择负责人"
        @close="state.showBelonger = false"
      >
        <c_AdminSelect
          @submit="
            (item) => {
              state.params.belonger_id = item.id;
              state.params.belonger = item.name + '/' + item.department_name;
              state.showBelonger = false;
            }
          "
          :id="state.model.belonger_id"
        ></c_AdminSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customermine_list, customermine_delete } from "@/http/customer";
import { customertype_tree } from "@/http/dictionary";
import { admin_cascader } from "@/utils/qFormat";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadAdmin();
      onLoadCustomerType();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      customermine_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    //获取客户类型
    const onLoadCustomerType = () => {
      customertype_tree().then((res) => {
        if (res.status == 200) state.customertypeData = res.data.data;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    const onDateChange = (value) => {
      if (value) state.params.contract_time = value[0] + " - " + value[1];
      else delete state.params.contract_time;
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(customermine_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onDateChange,
    };
  },
};
</script>
<style scoped></style>
